var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76656 3.59978C9.96183 3.40452 10.2784 3.40452 10.4737 3.59978L14.5203 7.64644C14.6141 7.74021 14.6668 7.86739 14.6668 8C14.6668 8.13261 14.6141 8.25978 14.5203 8.35355L10.4737 12.4002C10.2784 12.5955 9.96183 12.5955 9.76656 12.4002C9.5713 12.205 9.5713 11.8884 9.76656 11.6931L13.4597 8L9.76656 4.30688C9.5713 4.11162 9.5713 3.79504 9.76656 3.59978Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3335 8C2.3335 7.72386 2.55735 7.5 2.8335 7.5H14.0535C14.3296 7.5 14.5535 7.72386 14.5535 8C14.5535 8.27614 14.3296 8.5 14.0535 8.5H2.8335C2.55735 8.5 2.3335 8.27614 2.3335 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightWhite);
export default __webpack_public_path__ + "static/media/right-white.20e39cc03fb3c9923f98b8f953e47ffb.svg";
export { ForwardRef as ReactComponent };